module.exports = __webpack_public_path__ + "media/anim_bus_construction_site.7057891e.mp4";